import ucFirst from './ucFirst';

// Series display names seem to include markdown of some nature
var __italicsRegex = /_(.*?)_/g
export default function(name) {
  name = name.replace(__italicsRegex, function(match, p1) {
    return '<i>' + p1 + '</i>';
  });
  return ucFirst(name);
}
